import 'react-slideshow-image/dist/styles.css'
import React from 'react';
import { Slide } from 'react-slideshow-image';

const slideImages = [
    "https://images.pexels.com/photos/210766/pexels-photo-210766.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://cdn.pixabay.com/photo/2018/03/26/15/06/portrait-3262913_1280.jpg",
    "https://cdn.pixabay.com/photo/2020/12/03/10/33/headphones-5800167_1280.jpg"
];

const Slideshow = () => {
    const shareContent = (
        <div className="">
        <h1 className="font-weight-medium">Explore Top Music</h1>
        <p>One good thing about music, when it hits you,<br/>You feel no pain.</p>
         <a className="app-primary-button app-text-white app-button" href="/" >Try it free</a>
         <a className="app-text-white app-button " href="/" >Learn more &rsaquo;</a>
       </div>
    );
    return (
      <div>
        <div className="container-all">
        <div className="fixed-content">
         {shareContent}
        </div>
        <Slide 
        easing="ease" 
        infinite={true}
        indicators={false}
        autoplay={true}
        duration={5000}>
          <div className="each-slide">
            <div style={{'backgroundImage': `url(${slideImages[0]})`}}>
            </div>
          </div>
          <div className="each-slide">
            <div style={{'backgroundImage': `url(${slideImages[1]})`}}>
            </div>
          </div>
          <div className="each-slide">
            <div style={{'backgroundImage': `url(${slideImages[2]})`}}>
            </div>
          </div>
        </Slide>
      </div>
      </div>
    )
};

export default Slideshow;
